<template>
  <section class="section dark" v-if="tiles">
    <div class="container container-small">
      <ul class="tiles">
        <li class="tile" v-for="(tile, index) in tiles" :key="index"
            :class="{
              'active': index == activeItem
            }"
            @click="setActive(index)">
          <div class="tile-content" v-if="tile.title">
            <h4>{{ tile.title }}</h4>
            <div class="tile-icon" v-if="tile.id">
              <img :src="getImage(tile.id)" :alt="tile.id" />
            </div>
          </div>
          <span class="tile-number text-uppercase">{{ tile.title.charAt(0) }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'tilesSection',
  props: ['tiles'],
  components: {},
  data: function () {
    return {
      activeItem: 0
    }
  },
  methods: {
    getImage (id) {
      return require('@/assets/images/cekt/icons/' + id + '.svg')
    },
    setActive (index) {
      this.activeItem = index
    }
  }
}
</script>

<style scoped lang="scss">
  .section {
    &.dark {
      background-color: $bg-dark;
    }
    .container {
      display: flex;
      flex-flow: row nowrap;
      width: 90%;
      max-width: $container-content-max-width;
    }
  }

  .tiles {
    align-items: stretch;
    display: flex;
    list-style: none !important;
    margin: 0;
    padding: 0;
    position: relative;
    width: 100%;
  }

  .tile {
    background-color: $bg-dark;
    border-left: 1px solid rgba($color-inverted, 0.1);
    color: $text-light;
    cursor: pointer;
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
    min-height: 330px;
    user-select: none;
    width: 100%;

    &:last-of-type {
      border-right: 1px solid rgba($color-inverted, 0.1);
    }

    &-content {
      display: none;
      min-height: 270px;
      left: 0;
      overflow: hidden;
      padding: $gap-lg 5% 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      width: 100vw;

      h4 {
        color: $text-accent;
        font: {
          size: $font-l;
          weight: 700;
        }
        margin: 0 0 $gap-lg 0;

        #app.hight-contrast & {
          color: $contrast-accent;
        }

        .font-size-l & {
          font-size: $font-l-mobile;
        } // END
      } // END .tile-content h4;
    } // END .tile-content;

    &-icon {
      img {
        height: 86px;
        width: 86px;
      }
    } // END .tile-icon;

    &-number {
      display: inline-block;
      font: {
        size: 46px;
        weight: 700;
      }
      line-height: 1.3em;
      margin-top: auto;
      opacity: 0.2;
      padding: 0 0.1em;
      text-align: center;
      transition:  color $animation-duration ease-in-out, opacity $animation-duration ease-in-out;
      user-select: none;
      width: 100%;
    } // END .tile-number;

    &.active {
      .tile-content {
        background-color: $bg-dark;
        display: block;
        z-index: 100;
      } // END .tile-content;
    } // END .tile.active;

    &:hover,
    &.active {
      .tile-number {
        opacity: 1;
        color: $text-accent;
      }
    }

  } // END .tile;

  @include screen ('md') {
    .tile {
      min-height: 305px;

      &-content {
        display: block;
        min-height: 200px;
        opacity: 0;
        padding: $gap-sm $gap-md-alt;
        position: static;
        transition: opacity ($animation-duration / 2) ease-in-out;
        width: 100%;

        h4 {
          font: {
            size: $font-m;
            weight: normal;
          }

          .font-size-l & {
            font-size: $font-m-mobile;
          }
        } // END .tile-content h4;
      } // END .tile-content;

      &-icon {
        img {
          height: 56px;
          width: 56px;
        }
      } // END .tile-icon;

      &-number {
        font-size: 110px;
        text-align: right;
      } // END .tile-number

      &.active {
        width: 350px;
        min-width: 350px;

        .tile-content {
          opacity: 1;
        }
      } // END .tile.active;
    } // END .tile;

  } // END @include screen ('md');
</style>
